import { useCallback, useEffect, useState } from "react";
import { useCreate, useDelete, useStore, useUpdate } from "react-admin";
import { useDebouncedCallback } from "use-debounce";
import type { OrderItem, order_item } from "../models";
import { useQueryClient } from "@tanstack/react-query";
import { orderMeta as meta } from "./useOrder";

export const useOrderItem = (
    {
        buyerId,
        sellerId,
        orderId,
        itemId,
        quantity,
        variantId,
    }: order_item
): [number, (x: number) => void] => {
    const [u] = useUpdate<OrderItem>();
    const [c] = useCreate<OrderItem>();
    const [d] = useDelete<OrderItem>();
    const queryClient = useQueryClient();
    const [_, setOrderId] = useStore<number>("orderId");
    const id = `${sellerId}-${buyerId}-${orderId}-${itemId}`;
    const [quant, setQuant] = useState(quantity ?? 0);
    useEffect(() => {
    if(quantity !== undefined) {
        setQuant(quantity)
    }
}, [quantity]);
    const mutate = (q: number ) => { 
        if (q > 0) {
            if (quantity === 0) {
                return c("order_item", {
                            data: { buyerId, orderId, sellerId, variantId, itemId, quantity: q } as OrderItem,
                    }, { 
                        onSuccess: (result) => {
                        if(!orderId) {
                            setOrderId(result.orderId);
                        }
                        queryClient.invalidateQueries({ queryKey: ["order", "getOne", { id: `${sellerId}-${buyerId}-${orderId}`, meta }] });
                    } });
            } else {
                return u("order_item", {
                    id: `${sellerId}-${buyerId}-${orderId}-${itemId}`,
                    data: { quantity: q },
                    previousData: { quantity: 0 } as OrderItem,
                }, { 
                    onSuccess: () => {
                        queryClient.invalidateQueries({ queryKey: ["order", "getOne", { id: `${sellerId}-${buyerId}-${orderId}`, meta }] });
                    }
                });
            }
        } else if (q <= 0 && quantity > 0) {
            return d("order_item", { id }, { onSuccess: () => {
                queryClient.invalidateQueries({ queryKey: ["order", "getOne", { id: `${sellerId}-${buyerId}-${orderId}`, meta }] });
            }});
        }
    };
    const debounced = useCallback(useDebouncedCallback(() => mutate(quant), 300), [quant]);

    return [quant, (x: number) => { setQuant(x); debounced() }];
};

